import { gql } from "@apollo/client";

export const GET_USER_CONFIRM = gql`
  query UserConfirm($where: UserConfirmWhereInputOne!) {
    userConfirm(where: $where) {
      id
      code
      name
      addressCF
      fbID
      tags
      psid
      pageId
      shop {
        id
        name
        point
      }
      user {
        id
        nickname
        phone
        role
        gender
      }
      isBlocked
      asid
      isDeleted
      createdAt
      updatedAt
      note
    }
}
`;
export const GET_USER_CONFIRM_V2 = gql`
  query UserConfirmV2($where: UserConfirmWhereInputOneV2!) {
    userConfirmV2(where: $where) {
      id
      code
      name
      phone
      fbID
      tags
      psid
      addressCF
      pageId
      isBlocked
      asid
      isDeleted
      createdAt
      updatedAt
      note
      message
    }
  }
`;

export const GET_USER_CONFIRMS = gql`
  query UserConfirms($where: UserConfirmWhereInput, $orderBy: OrderByInput, $skip: Int, $limit: Int) {
    userConfirms(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
      total
      data {
        id
        code
        name
        addressCF
        fbID
        tags
        psid
        pageId
        phone
        shop {
          id
          name
          point
        }
        user {
          id
          nickname
          phone
          role
          gender
        }
        isBlocked
        asid
        isDeleted
        createdAt
        updatedAt
        note
      }
    }
}
`;